import ParkingTransactions from "@/visualizations/charts/components/ParkingTransactions.vue";
import PoliceRptByMonth from "@/visualizations/charts/components/PoliceRptByMonth.vue";
import ServiceRequest from "@/visualizations/charts/components/ServiceRequest.vue";
import WazeTraffic from "@/visualizations/charts/components/WazeTraffic.vue";
import RealEstateAssessment from "@/visualizations/charts/components/RealEstateAssessment.vue";
import ParkingTransactionsByRegion from "@/visualizations/charts/components/ParkingTransactionsByRegion.vue";
import PoliceIncidentHeatMap from "@/visualizations/maps/components/PoliceIncidentHeatMap.vue";
import FarmersMarketMap from "@/visualizations/maps/components/FarmersMarket.vue";
import FireIncidents from "@/visualizations/charts/components/FireIncidents.vue";
import OutdoorWirelessStats from "@/visualizations/charts/components/OutdoorWirelessStats.vue";

let startyear = new Date().getFullYear();

const charts = [
  {
    title: "Parking Meter Transactions",
    description: "Sum of all metered parking payments made by credit card through single- and multi-space meters and via pay-by-cell.",
    component: ParkingTransactions,
    duration: 5,
    group: 2,
    slider: false,
    startyear: startyear,
    note: "Note: Latest period data may not be complete.",
    dialog: {
      duration: new Date().getMonth(),
      group: 0,
      slider: true,
      startyear: startyear
    },
    id: 148,
    url:
      "https://datahub-v2.arlingtonva.us/api/ParkingMeter/ParkingTransactionsByMonth",
    download:
      "https://download.data.arlingtonva.us/ParkingMeter/ParkingTransactions.txt.gz",
    visible: true
  },
  {
    title: "Residential Real Estate Assessments",
    description: "Average Real Estate Assessments by residential property type, excluding mid-year changes in value (e.g., appeals, redevelopment)",
    component: RealEstateAssessment,
    duration: 10,
    slider: false,
    startyear: startyear,
    note: "Note: Last 4 years data may be modified due to adjustments in value.",
    dialog: {
      duration: 20,
      slider: true,
      startyear: startyear
    },
    id: 9,
    url: "https://datahub-v2.arlingtonva.us/api/RealEstate/Assessment",
    download: "https://download.data.arlingtonva.us/RealEstate/Assessment.txt.gz",
    visible: true
  },
  {
    title: "Traffic Alerts Reported via Waze",
    description: "Near real-time traffic alerts, congestion and accidents reported by community to Waze",
    component: WazeTraffic,
    groupby: "Month",
    duration: 6,
    slider: false,
    startyear: startyear,
    note: "Note: Data is near real-time as reported by Waze app users.",
    dialog: {
      duration: 12,
      slider: true,
      groupby: "Month",
      startyear: startyear
    },
    url: "https://datahub-v2.arlingtonva.us/api/Waze/AlertsGroupedByMonth",
    visible: false
  },
  {
    title: "Police Incidents",
    description: "Crime report data",
    component: PoliceRptByMonth,
    groupby: "Month",
    duration: 6,
    id: 84,
    slider: false,
    dialog: {
      slider: true,
      groupby: "Month",
      duration: 12,
      startyear: startyear
    },
    url: "https://datahub-v2.arlingtonva.us/api/police/IncidentLogByMonth",
    download:
      "https://download.data.arlingtonva.us/Police/PoliceIncidentLog.txt.gz",
    visible: false
  },
  {
    title: "Fire Incidents",
    description: "All emergency service requests directed to the County’s Fire Department",
    component: FireIncidents,
    groupby: "Month",
    duration: 6,
    id: 84,
    slider: false,
    dialog: {
      slider: true,
      groupby: "Month",
      duration: 12,
      startyear: startyear
    },
    url: "https://datahub-v2.arlingtonva.us/api/Fire/IncidentLogByMonth",
    download:
      "https://download.data.arlingtonva.us/Uploads/AutomatedJobs/FireIncidents.csv",
    visible: true
  },
  {
    title: "Outdoor Wireless Hotspot Usage",
    description: "Arlington County has multiple outdoor Wi-Fi hotspots offering free wireless internet (ArlingtonWireless) at public spaces including community centers, libraries and parks. The data is collected via a wireless network management system. Monthly usage counts are the sum of unique, daily user connections to each hotspot.",
    component: OutdoorWirelessStats,
    groupby: "Month",
    duration: 6,
    id: 328,
    slider: false,
    dialog: {
      slider: true,
      groupby: "Month",
      duration: 12,
      startyear: startyear
    },
    url: "https://download.data.arlingtonva.us/Uploads/AutomatedJobs/Outdoor+Wireless+Usage+Stats.json",
    download:
      "https://datahub-datasets.s3.amazonaws.com/Uploads/AutomatedJobs/Outdoor+Wireless+Usage+Stats.xlsx",
    visible: true
  },
  {
    title: "Constituent Service Requests",
    description: `Count of the most recent 6 months of service requests submitted via the County’s online “Report a Problem” tool`,
    component: ServiceRequest,
    groupby: "Month",
    duration: 6,
    id: 100,
    url:
      "https://datahub-v2.arlingtonva.us/api/Environmental/Service+Request",
    download:
      "https://download.data.arlingtonva.us/Environmental/ServiceRequest.txt.gz",
    visible: true
  },
  {
    title: "Police Incident Heatmap",
    description: "Heat map for Crime data in Arlington for last 6 months",
    component: PoliceIncidentHeatMap,
    limit: 1000,
    width: 375,
    height:400,
    id: 84,
    maptype: 'satellite',
    zoom: 12,
    slider: false,
    url:
      "https://datahub-v2.arlingtonva.us/api/police/IncidentLogByMonth",
    download:
      "https://download.data.arlingtonva.us/Police/PoliceIncidentLog.txt.gz",
    dialog: {
      maptype: 'satellite',
      limit: 1000,
      width: 1000,
      height: 600,
      zoom: 13,
      slider: true
    },
    visible: false
  },
  {
    title: "Farmers Markets",
    description: "Map of Farmers Markets in Arlington",
    component: FarmersMarketMap,
    width: 375,
    height:'400px',
    id: 37,
    maptype: 'roadmap',
    zoom: 12,
    url:
      "https://download.data.arlingtonva.us/Uploads/AutomatedJobs/Farmers+market.json",
    download:
      "https://download.data.arlingtonva.us/Uploads/AutomatedJobs/Farmers+market.xlsx",
    dialog: {
      maptype: 'roadmap',
      width: 1000,
      height: '600px',
      zoom: 13
    },
    visible: true
  },
  {
    title: "Parking Meter Transactions By Region",
    description: "Sum of all metered parking payments broken down by 10 regions with most transactions.",
    component: ParkingTransactionsByRegion,
    length: 6,
    group: "month",
    slider: false,
    startyear: startyear,
    note: "Note: Latest period data may not be complete.",
    dialog: {
      length: 10,
      group: 0,
      slider: true,
      startyear: startyear
    },
    id: 148,
    url:
      "https://datahub-v2.arlingtonva.us/api/ParkingMeter/ParkingTransactionsByMonth",
    download:
      "https://download.data.arlingtonva.us/ParkingMeter/ParkingTransactions.txt.gz",
    visible: false
  },
];

export default charts;